import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import styled, { css } from 'styled-components';
import moment from 'moment';

import { Select } from '_components';
import { _ } from '_locales';

import ErrorText from './ErrorText';

const Container = styled.div`
  margin: auto;
  max-width: 465px;
  margin-bottom: 15px;
`;

const Title = styled.h2`
  font-size: 20px !important;
  margin-bottom: 20px;
  font-weight: 500 !important;
`;

const DayOption = styled.label`
  border-radius: 5px;
  font-size: 16px !important;
   
  display: inline;
  text-align: center;
  cursor: pointer;
  font-weight: 300 !important;
  padding: 3px 2px;
  border: ${({ checked }) => (checked ? '2px solid #ccc' : '2px solid transparent')};

  &:focus {
    outline: none;
  }
`;

const Text = styled.h3`
  float: left;
  color: #595959;
  font-size: 14px !important;
  font-weight: 400 !important;
`;

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RadioButtonContainer = styled.fieldset`
  border: none;  
  display: flex;
  justify-content: space-between;
`;

const Legend = styled.legend`
  opacity: 0;
  display: block;
  height: 0;
`;

const DaysContainer = styled.div`
  border: none;
  margin-bottom: 10px;

  & input {
    opacity: 0; 
    border: none;
    outline: none;
    transform: scale(0.01);

    &:focus {
      outline: 0;
    }
  }
`;

const DayLabel = styled.label`
  padding: 5px 10px;
  font-size: 16px !important;
  cursor: pointer;
  font-weight: 300 !important;
  border: ${({ isFocused }) => (isFocused ? '2px solid #005FCD' : '2px solid transparent')};
  border-radius: 5px;

  &:hover {
    background: #F3F2F2;
  }
`;
// End of Style

const createHour = (time) => ({ title: time.format('h:mm A'), value: time.format('H:mm:ss') });

const ReminderTime = () => {
  const [focusedDay, setFocusedDay] = useState();
  // Hooks
  const { register, formState: { errors }, watch } = useFormContext();
  const selectedDay = watch('day');

  const hours = [];
  for (let v = 1; v <= 24; v += 1) {
    hours.push(createHour(moment(`${v}:00`, ['HH:mm'])));
    // hours.push(moment(`${v}:00`, ['HH:mm']).format('h:mm A'));
    if (v === 24) break;
    hours.push(createHour(moment(`${v}:30`, ['HH:mm'])));
  }
  hours.push(createHour(moment('00:30', ['HH:mm'])));

  const daysData = [
    { dayNameAbbr: 'reminder.sun', abbr: 'sun', dayName: 'Sunday' },
    { dayNameAbbr: 'reminder.mon', abbr: 'mon', dayName: 'Monday' },
    { dayNameAbbr: 'reminder.tue', abbr: 'tue', dayName: 'Tuesday' },
    { dayNameAbbr: 'reminder.wed', abbr: 'wed', dayName: 'Wednesday' },
    { dayNameAbbr: 'reminder.thu', abbr: 'thu', dayName: 'Thuesday' },
    { dayNameAbbr: 'reminder.fri', abbr: 'fri', dayName: 'Friday' },
    { dayNameAbbr: 'reminder.sat', abbr: 'sat', dayName: 'Saturday' },
  ];

  return (
    <Container>
      <Title style={{ textAlign: 'center' }}>
        {_('reminder.when_should_we_remind_you')}
      </Title>

      <RadioButtonContainer>
        <Legend>{_('reminder.when_should_we_remind_you')}</Legend>
        {daysData.map(({ dayName, abbr, dayNameAbbr }) => (
          <DaysContainer key={abbr}>
            <DayLabel
              htmlFor={abbr}
              isFocused={focusedDay === abbr}
            >
              {_(`${dayNameAbbr}`)}
            </DayLabel>
            <input
              aria-label={dayName}
              onFocus={() => setFocusedDay(abbr)}
              type="radio"
              value={abbr}
              name="day"
              ref={register}
              id={abbr}
            />
          </DaysContainer>
        ))}
      </RadioButtonContainer>

      <ContentContainer ContentContainer>
        <Text>{_('reminder.time')}</Text>
        <Select
          name="hour"
          // id="country-code"
          aria-label="Select the time"
          selectRef={register}
          short
          style={{
            width: '90px',
            float: 'left',
            margin: '7px 13px auto',
            border: '1px solid #ccc',
            borderRadius: 10,
            paddingLeft: 7,
            textAlign: 'left'
          }}
        >
          {/* Showing hours list as option select */}
          {
            hours.map(({ title, value }) => (
              <option
                value={value}
                key={value}
              >
                {title}
              </option>
            ))
          }
        </Select>

      </ContentContainer>
      {
        errors.day && (
          <ErrorText>{errors.day.message}</ErrorText>
        )
      }
    </Container>
  );
};
export default ReminderTime;
